module.exports = __webpack_public_path__ + "img/panboyu.4bccee3f.jpg";